module.exports = __webpack_public_path__ + "img/DSC_0180 teatro criss.0333e9ef.jpg";